import { create } from 'zustand';
import { ComponentFactory } from './ComponentRegistry';
import uuid from 'uuid';
import { extractNodes, extractEdges } from '../../utils/CanvasUtil';

const usePreviewStore = create((set, get) => ({
  download: undefined,
  template: undefined,
  project_id: '',
  project_name: '',
  last_modified: undefined,
  components: [],
  project_description: '',
  imagePath: undefined,
  projectStatus: undefined,
  canvas: undefined,
  nodes: undefined,
  edges: undefined,
  draftVersion: undefined,
  publishedVersion: undefined,

  zoom_level: 75,
  active_diagram: {},
  locked: true,

  setWorkflow: workflow => {
    const elements = get().readDiagram(workflow.components);
    set({
      project_id: workflow.projectId,
      project_name: workflow.name,
      last_modified: workflow.lastModified,
      project_description: workflow.description,
      components: workflow.components,
      canvas: elements,
      nodes: extractNodes(elements),
      edges: extractEdges(elements),
      imagePath: workflow.imagePath,
      projectStatus: workflow.status,
    });
  },

  createNode: (component, template) => {
    return {
      id: component.componentId,
      type: 'component',
      data: {
        logo: template.logo,
        hasInput: template.hasInput ? template.hasInput : false,
        hasOutput: template.hasOutput ? template.hasOutput : false,
        type: component.type,
        displayName: template.displayName,
        description: component.description,
        next: component.nextComponents,
        label: component.name ? component.name : template.displayName,
        baseColor: template.baseColor,
      },
      position: { x: component.viewData.x, y: component.viewData.y },
    };
  },

  createLink: (newNodeId, nextId, baseColor) => {
    return {
      id: uuid(),
      source: newNodeId,
      target: nextId,
      markerEnd: { type: 'arrowclosed', color: '#868686' },
      type: 'link',
      style: { strokeWidth: '3px', stroke: baseColor },
    };
  },

  readDiagram: components => {
    let diagram = [];
    if (components) {
      components.map((component, id) => {
        if (ComponentFactory[component.type] !== undefined) {
          const newNode = get().createNode(component, ComponentFactory[component.type]);
          diagram.push(newNode);
          if (newNode.data.next && newNode.data.next.length != 0) {
            newNode.data.next.map((next, nextId) => {
              const newLink = get().createLink(
                newNode.id,
                next.componentId,
                newNode.data.baseColor
              );
              diagram.push(newLink);
            });
          }
        }
      });
    }
    return diagram;
  },

  setCanvas: canvas => set({ canvas }),
  setNodes: nodes => set({ nodes }),
  setEdges: edges => set({ edges }),

  clear: () => {
    set({
      project_id: '',
      project_name: '',
      project_description: '',
      components: [],
    });
  },

  getAggregate: () => {
    const s = get();
    return {
      project_id: s.project_id,
      project_name: s.project_name,
      draftVersion: s.draftVersion,
      publishedVersion: s.publishedVersion,
      project_description: s.project_description,
      imagePath: s.imagePath,
      components: s.components ? [...s.components] : [],
    };
  },
}));

export default usePreviewStore;
